// eslint-disable-next-line no-use-before-define
import React from 'react';
import { VueInReact } from 'vuera-ts';
import Button from '../../../../components/button/Button.vue';

const ReactButton = VueInReact(Button);

const EmptyChannelListParentView = () => {
  return (
    <div className="text-center">
      <h2 className="text-h3 mb-8" style={{ marginTop: '96px' }}>
        No messages
      </h2>
      <p className="text-body text-grey-text-subdued mx-16 mb-24">Your conversations with sitters will appear here</p>
      <ReactButton href="/availability/search" size="medium" value="Search sitters" />
    </div>
  );
};

export default EmptyChannelListParentView;
